import cosineSimilarity from 'compute-cosine-similarity'

class SimilarityManagerClass {
    calculateCosineSimilarity(val1: any, val2: any): number {
        if (!val1 && !val2) return 0
        if (!val1 || !val2) return 0
        if (val1 === '' && val2 === '') return 0
        if (val1.value === '' && val2.value === '') return 0
        const normalize = (val: any) =>
            String(val)
                .toLowerCase()
                .trim()
                .replace(/[^\w\s]/g, '')
                .replace(/\s+/g, ' ')

        const normalizedVal1 = normalize(val1)
        const normalizedVal2 = normalize(val2)

        const tokens1 = normalizedVal1.split(' ')
        const tokens2 = normalizedVal2.split(' ')
        const allTokens = Array.from(new Set([...tokens1, ...tokens2]))

        const vector1 = allTokens.map(token => tokens1.filter(t => t === token).length)
        const vector2 = allTokens.map(token => tokens2.filter(t => t === token).length)

        return cosineSimilarity(vector1, vector2)
    }
}

const SimilarityManager = new SimilarityManagerClass()
export default SimilarityManager
